import axios from 'axios'

export const fetchTermsConditions = () =>
  axios.get('/public/terms-conditions').then((response) => response.data)
